export default "__VITE_ASSET__C8hPLmjr__"